import { useEffect } from "react"
import { ReactKeycloakProvider } from "@react-keycloak/web"
import keycloak from "./misc/Keycloak"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Col, Container, Row } from "reactstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "./App.css"
import axios from "axios"
import {
    setViditelnost,
    setPouziti,
    setKlasifikace,
    setRodinyPovrchu,
    setRodinyVybaveni,
} from "./redux/actions/miscActions"
import Menu from "./comp/Menu"
import Default from "./block/Default"
import EditDoplnek from "./block/EditDoplnek"
import EditPovrch from "./block/EditPovrch"
import EditVybaveni from "./block/EditVybaveni"
import Login from "./block/Login"
import LoginDashboard from "./block/LoginDashboard"
import NewPovrch from "./block/NewPovrch"
import NewDoplnek from "./block/NewDoplnek"
import NewVybaveni from "./block/NewVybaveni"
import SeznamPovrchu from "./block/SeznamPovrchu"
import SeznamDoplnku from "./block/SeznamDoplnku"
import SeznamVybaveni from "./block/SeznamVybaveni"
import ViewingPovrch from "./block/ViewingPovrch"
import ViewingDoplnek from "./block/ViewingDoplnek"
import ViewingVybaveni from "./block/ViewingVybaveni"
import URLEndPointBE from "./comp/URLEndPointBE"

import { createBrowserHistory } from "history"
import PrivateRoute from "./misc/PrivateRoute"
export const history = createBrowserHistory()

function App() {
    const dispatch = useDispatch()

    let onKeycloakEvent = (event: any, error: any) => {
        console.log("onKeycloakEvent", event, error)
    }

    let onKeycloakTokens = (tokens: any) => {
        console.log("onKeycloakTokens", tokens)
        console.log(keycloak.idTokenParsed) //keycloak.idTokenParsed.token SEND
        console.log(keycloak.resourceAccess)
        // @ts-ignore                       vv - Dependent on project name
        console.log(keycloak.resourceAccess.d_app_katalog_prvku1)
        //try
        console.log("keycloak.token")
        // @ts-ignore
        console.log(keycloak.token)
    }

    //Rewrite to Callback Hell? fix
    //https://dev.to/nickparsons/javascript-promises-and-why-asyncawait-wins-the-battle-1g8a

    async function FetchViditelnost() {
        const _viditelnost: any = await axios
            .get(URLEndPointBE + `/dict-misc/viditelnost`)
            .catch(error => {
                console.log("Err viditelnost", error)
            })
        return _viditelnost.data
    }
    async function FetchPouziti() {
        const _pouziti: any = await axios
            .get(URLEndPointBE + `/dict-misc/pouziti`)
            .catch(error => {
                console.log("Err pouziti", error)
            })
        return _pouziti.data
    }
    async function FetchKlasifikace() {
        const _klasifikace: any = await axios
            .get(URLEndPointBE + `/dict-misc/klasifikace`)
            .catch(error => {
                console.log("Err klasifikace", error)
            })
        return _klasifikace.data
    }
    async function FetchRodinyPovrchu() {
        const _rodiny_povrchu: any = await axios
            .get(URLEndPointBE + `/dict-misc/rodiny-povrchu`)
            .catch(error => {
                console.log("Err rodiny vybaveni", error)
            })
        return _rodiny_povrchu.data
    }
    async function FetchRodinyVybaveni() {
        const _rodiny_vybaveni: any = await axios
            .get(URLEndPointBE + `/dict-misc/rodiny-vybaveni`)
            .catch(error => {
                console.log("Err rodiny vybaveni", error)
            })
        return _rodiny_vybaveni.data
    }
    const FetchSetMisc = async () => {
        const viditelnost = FetchViditelnost()
        const pouziti = FetchPouziti()
        const klasifikace = FetchKlasifikace()
        const rodiny_povrchu = FetchRodinyPovrchu()
        const rodiny_vybaveni = FetchRodinyVybaveni()
        Promise.all([
            viditelnost,
            pouziti,
            klasifikace,
            rodiny_povrchu,
            rodiny_vybaveni,
        ]).then(result => {
            console.log(
                "App.tsx result - FetchSetMisc() called w/ Promise.all([viditelnost, pouziti, klasifikace, rodiny_povrchu, rodiny_vybaveni])"
            )
            console.log(result)
            dispatch(setViditelnost(result[0]))
            dispatch(setPouziti(result[1]))
            dispatch(setKlasifikace(result[2]))
            dispatch(setRodinyPovrchu(result[3]))
            dispatch(setRodinyVybaveni(result[4]))
        })
    }
    useEffect(() => {
        console.log("process.env.PUBLIC_URL")
        console.log(process.env.PUBLIC_URL)
        FetchSetMisc()
    }, [])
    return (
        /*https://medium.com/devops-dudes/secure-front-end-react-js-and-back-end-node-js-express-rest-api-with-keycloak-daf159f0a94e*/
        <ReactKeycloakProvider
            authClient={keycloak}
            onEvent={onKeycloakEvent}
            onTokens={onKeycloakTokens}
        >
            <Router basename={process.env.PUBLIC_URL}>
                <div className="App">
                    <Container>
                        <Row className="katHead printHide">
                            <Col>
                                <span className="alignLeft">
                                    <h1>
                                        <b>KATALOG DOPORUČENÝCH PRVKŮ</b>
                                    </h1>
                                    <h2>VEŘEJNÉHO PROSTRANSTVÍ HL.M.PRAHY</h2>
                                </span>
                                <span className="alignRight">
                                    <img
                                        width={150}
                                        height={40}
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/ipr_logo.png"
                                        }
                                        alt={"ipr_logo"}
                                    />
                                </span>
                            </Col>
                        </Row>
                        <Row className="printHide">
                            <Col md={12}>
                                <Menu />
                            </Col>
                        </Row>
                        <Row>
                            <Col
                                md={12}
                                className="katAppContext"
                            >
                                <Routes>
                                    <Route
                                        path="/"
                                        element={<Default />}
                                    />
                                    {/*<Route path="/login" element={<Login/>}/>*/}
                                    {/*<Route path="/dashboard" element={<PrivateRoute roles={['admin', 'user']}> <LoginDashboard/> </PrivateRoute>}/>*/}
                                    <Route
                                        path="/povrchy"
                                        element={<SeznamPovrchu />}
                                    />{" "}
                                    {/*TODO - SUCC +/edit  */}
                                    <Route
                                        path="/povrchy/:params"
                                        element={<SeznamPovrchu />}
                                    />
                                    <Route
                                        path="/povrchy/new"
                                        element={
                                            <PrivateRoute
                                                roles={["admin", "user"]}
                                            >
                                                {" "}
                                                <NewPovrch />{" "}
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/povrchy/edit/:povrchId"
                                        element={
                                            <PrivateRoute
                                                roles={["admin", "user"]}
                                            >
                                                {" "}
                                                <EditPovrch />{" "}
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/povrchy/povrch/:povrchId"
                                        element={<ViewingPovrch />}
                                    />
                                    <Route
                                        path="/doplnky"
                                        element={<SeznamDoplnku />}
                                    />{" "}
                                    {/*TODO - SUCC +/edit  */}
                                    <Route
                                        path="/doplnky/:params"
                                        element={<SeznamDoplnku />}
                                    />
                                    <Route
                                        path="/doplnky/new"
                                        element={
                                            <PrivateRoute
                                                roles={["admin", "user"]}
                                            >
                                                {" "}
                                                <NewDoplnek />{" "}
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/doplnky/edit/:doplnekId"
                                        element={
                                            <PrivateRoute
                                                roles={["admin", "user"]}
                                            >
                                                {" "}
                                                <EditDoplnek />{" "}
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/doplnky/doplnek/:doplnekId"
                                        element={<ViewingDoplnek />}
                                    />
                                    <Route
                                        path="/vybaveni"
                                        element={<SeznamVybaveni />}
                                    />{" "}
                                    {/*TODO - SUCC +/edit  */}
                                    <Route
                                        path="/vybaveni/:params"
                                        element={<SeznamVybaveni />}
                                    />
                                    <Route
                                        path="/vybaveni/new"
                                        element={
                                            <PrivateRoute
                                                roles={["admin", "user"]}
                                            >
                                                {" "}
                                                <NewVybaveni />{" "}
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/vybaveni/edit/:vybaveniId"
                                        element={
                                            <PrivateRoute
                                                roles={["admin", "user"]}
                                            >
                                                {" "}
                                                <EditVybaveni />{" "}
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/vybaveni/vybaveni/:vybaveniId"
                                        element={<ViewingVybaveni />}
                                    />
                                </Routes>
                            </Col>
                        </Row>
                        <Row className="printHide">
                            <Col>
                                <p className="katFooter">
                                    &copy; Institut plánování a rozvoje hlavního
                                    města Prahy {new Date().getFullYear()},
                                    všechna práva vyhrazena.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Router>
        </ReactKeycloakProvider>
    )
}

export default App
